<div class="container">
  <hyperkit-typography
    class="page-title"
    variant="h1"
    align="left"
    color="primary"
    >Profile</hyperkit-typography
  >
  <div class="profile-wrapper">
    <section class="section">
      <div class="section-title">
        <hyperkit-typography variant="h4" align="left" color="primary"
          >Personal Information</hyperkit-typography
        >
        <div class="options">
          @if (profileSaved) {
            <hyperkit-typography
              display="inline"
              variant="body"
              size="sm"
              align="left"
              color="primary"
              >Changes Saved</hyperkit-typography
            >
          }
          <hyperkit-button
            class="add-btn"
            size="small"
            variant="standard"
            color="tertiary"
            text="Save Changes"
            (click)="onSave()"
          ></hyperkit-button>
        </div>
      </div>
      <form [formGroup]="userForm">
        <div class="form-grid">
          <div class="form-group">
            <hyperkit-input
              class="hyperkit-component"
              type="text"
              label="First Name"
              formControlName="firstName"
            ></hyperkit-input>
          </div>
          <div class="form-group">
            <hyperkit-input
              class="hyperkit-component"
              type="text"
              label="Last Name"
              formControlName="lastName"
            ></hyperkit-input>
          </div>
          <div class="form-group">
            <hyperkit-input
              class="hyperkit-component"
              type="phone"
              label="Phone Number"
              formControlName="phoneNumber"
            ></hyperkit-input>
          </div>
          <div class="form-group">
            <hyperkit-input
              class="hyperkit-component"
              type="text"
              label="Email"
              formControlName="email"
            ></hyperkit-input>
          </div>
          <div class="form-group">
            <hyperkit-badge
              variant="neutral"
              text="Account Role"
            ></hyperkit-badge>
            <hyperkit-typography
              display="inline"
              variant="emphasized"
              size="sm"
              align="left"
              color="primary"
              >{{ role | snakeToTitle }}</hyperkit-typography
            >
          </div>
          <div class="form-group">
            <hyperkit-badge variant="neutral" text="Joined"></hyperkit-badge>
            <hyperkit-typography
              display="inline"
              variant="emphasized"
              size="sm"
              align="left"
              color="primary"
              >{{ createdAt | date }}</hyperkit-typography
            >
          </div>
        </div>
      </form>
    </section>

    <section class="section">
      <div class="section-title">
        <hyperkit-typography variant="h4" align="left" color="primary"
          >Change Password</hyperkit-typography
        >
      </div>
      <form [formGroup]="passwordForm" (ngSubmit)="onChangePassword()">
        <div class="password-section">
          <div class="password-requirements">
            <div class="form-label">
              <hyperkit-badge
                variant="neutral"
                text="Password must contain:"
              ></hyperkit-badge>
            </div>
            <ul>
              <li>
                <hyperkit-typography
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="primary"
                  >At least 6 characters</hyperkit-typography
                >
              </li>
              <li>
                <hyperkit-typography
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="primary"
                  >At least 1 upper case letter</hyperkit-typography
                >
              </li>
              <li>
                <hyperkit-typography
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="primary"
                  >At least 1 upper number</hyperkit-typography
                >
              </li>
              <li>
                <hyperkit-typography
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="primary"
                  >At least 1 special character ({{
                    specialCharacters
                  }})</hyperkit-typography
                >
              </li>
            </ul>
          </div>
          <div class="password-form">
            <div class="input-group">
              <hyperkit-input
                class="hyperkit-component"
                type="text"
                label="Old Password"
                placeholder="Old Password"
                formControlName="oldPassword"
              ></hyperkit-input>
            </div>
            <div class="input-group">
              <hyperkit-input
                class="hyperkit-component"
                [pattern]="passRegex"
                type="text"
                label="New Password"
                placeholder="New Password"
                formControlName="newPassword"
              ></hyperkit-input>
            </div>
            <div class="input-group">
              <hyperkit-input
                class="hyperkit-component"
                [pattern]="passRegex"
                type="text"
                label="Confirm Password"
                placeholder="Confirm Password"
                formControlName="confirmNewPassword"
              ></hyperkit-input>
            </div>
            @if (
              !passwordForm.controls.confirmNewPassword.valid &&
              passwordForm.controls.newPassword.valid &&
              passwordForm.controls.newPassword.touched &&
              passwordForm.controls.confirmNewPassword.dirty
            ) {
              <hyperkit-error
                class="form-error"
                error="Passwords do not match."
              ></hyperkit-error>
            }
            <div class="options">
              @if (passwordChanged) {
                <hyperkit-typography
                  display="inline"
                  variant="body"
                  size="sm"
                  align="left"
                  color="primary"
                  >Password Updated</hyperkit-typography
                >
              }
              <hyperkit-button
                type="submit"
                [disabled]="!passwordForm.valid"
                size="small"
                variant="standard"
                color="tertiary"
                text="Change Password"
              ></hyperkit-button>
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</div>
